import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
import s from './Carousel.scss';

function NextArrow(props) {
  const { onClick } = props;
  let nextArrowClass = props.className;
  nextArrowClass += props.showCarouselNextLoader ? ' dotted-loader' : '';
  return (
    <div
      {...props}
      className={nextArrowClass}
      onClick={() => {
        if (typeof onClick === 'function') {
          onClick();
        }
      }}
    >
      <i />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div {...props} onClick={onClick}>
      <i />
    </div>
  );
}

class Carousel extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
  };
  static defaultProps = {
    className: '',
    onClick: () => {},
  };

  render() {
    const settings = {
      dots: this.props.dots || true,
      infinite: this.props.infinite || false,
      speed: this.props.speed || 500,
      slidesToShow: this.props.slidesToShow || 2.5,
      slidesToScroll: this.props.slidesToScroll || 1,
      initialSlide: this.props.initialSlide || 0,
      responsive: this.props.resposive || null,
      autoplay: this.props.autoplay || false,
      autoplaySpeed: this.props.autoplaySpeed || 3000,
      afterChange:
        (!this.props.showCarouselNextLoader
          ? this.props.handleCarouselNextClick
          : null) || null,
      nextArrow: (
        <NextArrow
          showCarouselNextLoader={this.props.showCarouselNextLoader}
          {...this.props}
        />
      ),
      prevArrow: <PrevArrow {...this.props} />,
    };
    // assigning non slick props in settings makes resposive setting break
    // const settings = Object.assign({}, defaults, this.props);
    return <Slider {...settings}>{this.props.children}</Slider>;
  }
}

export default Carousel;
